import { Form, Select, Button, Flex } from "antd";
import React from "react";

export default function ContactAgentsForm(
  props: {
    states: any[];
    cities: any[]; 
    findAgents;
    filterCities;
    filterStates;
  }
) {
  const {states, cities, findAgents, filterCities, filterStates} = props;
  
  return (
    <Form layout="vertical" onFinish={findAgents}>
      <Form.Item wrapperCol={{ span: 24 }} label="Select State" name="state">
        <Select 
          allowClear={true} 
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
          } 
          placeholder="Please select" 
          options={states.map((s:any) => {return {label: s, value: s}})} 
          onChange={filterCities}/>
      </Form.Item>
      <Form.Item wrapperCol={{ span: 24 }} label="City" name="city">
        <Select 
          allowClear={true} 
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
          } 
          placeholder="Please select" 
          options={cities.map((s:any) => {return {label: s, value: s}})} 
          onChange={filterStates}/>
      </Form.Item>
      <Flex align="flex-end" justify="center">
        <Button type="primary" className="find-button" htmlType="submit">Find Agent</Button>
      </Flex>
    </Form>
  )
}